var windowScroll = $(window).scrollTop();

$(window).scroll(function() {
    var scrollHeight = $(document).height(), //ドキュメントの高さ
    windowHeight = $(window).height(), //ウィンドウの高さ
    pageBottom = scrollHeight - windowHeight; //ドキュメントの高さ - ウィンドウの高さ
    var scroll = $(this).scrollTop();
    if (windowScroll < scroll && scroll > 100) {
        $("#header").addClass('header--hidden');
        $("#header").removeClass('header--visible');
        if ($('body').hasClass('nav_open')) {
            $("#header").removeClass('header--hidden');
            $("#header").addClass('header--visible');
        }
    } else if ($('body').hasClass('nav_open')) {
        $("#header").removeClass('header--hidden');
        $("#header").addClass('header--visible');
    } else if(pageBottom <= windowScroll) {
        $("#header").addClass('header--hidden');
        $("#header").removeClass('header--visible');
    } else {
        $("#header").removeClass('header--hidden');
        $("#header").addClass('header--visible');
    }
    windowScroll = scroll;
});